<div class="dialog-sign-and-submit dialog-large dialog-flex-direction-column">
    <div class="dialog-inner-sign-and-submit dialog-inner-horizontal">
        Sign by retyping your name
    </div>
    <!--<div class="dialog-inner-sign-and-submit">
        {{name}}
    </div>-->
    <div class="dialog-inner-sign-and-submit">
        <mat-form-field>
            <mat-label>{{name}}</mat-label>
            <input matInput [(ngModel)]="signature" required>
        </mat-form-field>
    </div>
</div>
<div class="buttons">
    <button class="button-mgis" (click)="close()" class="chat-button chat-button-define" mat-flat-button>Back</button>
    <button class="button-mgis" (click)="sign()" class="chat-button chat-button-define" mat-flat-button>Sign & Submit</button>
</div>